import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="font-heading text-xl md:text-2xl text-foreground-950 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
          >
            妈妈的朋友们
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm transition-colors duration-200 whitespace-nowrap ${
                isActive('/') && location.pathname === '/'
                  ? 'text-primary-500 font-medium'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/mama-yu-guimi"
              className={`text-sm transition-colors duration-200 whitespace-nowrap ${
                isActive('/category')
                  ? 'text-primary-500 font-medium'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              故事分类
            </Link>
            <Link
              to="/about"
              className={`text-sm transition-colors duration-200 whitespace-nowrap ${
                isActive('/about')
                  ? 'text-primary-500 font-medium'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className="md:hidden w-8 h-8 flex items-center justify-center text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer"
            aria-label="打开菜单"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col space-y-3">
            <Link
              to="/"
              className={`text-sm py-2 transition-colors whitespace-nowrap ${
                isActive('/') && location.pathname === '/'
                  ? 'text-primary-500 font-medium'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/mama-yu-guimi"
              className={`text-sm py-2 transition-colors whitespace-nowrap ${
                isActive('/category')
                  ? 'text-primary-500 font-medium'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              故事分类
            </Link>
            <Link
              to="/about"
              className={`text-sm py-2 transition-colors whitespace-nowrap ${
                isActive('/about')
                  ? 'text-primary-500 font-medium'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}